<kodit-dropdown
  formCtrlId="email-dropdown"
  [options]="items"
  [formCtrl]="formCtrl">
</kodit-dropdown>

